import Api from './Api';

const END_POINT = 'orders';

export default {
    getSummary(customer_id = null) {
        let request = {
            params: {
                customer_id
            }
        }
        return Api.get(`${END_POINT}/summary`, request)
    },

    getToDispatch (filters) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}/to-dispatch`, request);
    }
}
